module.exports = __webpack_public_path__ + "img/icon_empresas.f364e1c2.svg";